import { render, staticRenderFns } from "./SuperTableAssignRefFriend.vue?vue&type=template&id=6b7e0228"
import script from "./SuperTableAssignRefFriend.vue?vue&type=script&lang=js"
export * from "./SuperTableAssignRefFriend.vue?vue&type=script&lang=js"
import style0 from "./SuperTableAssignRefFriend.vue?vue&type=style&index=0&id=6b7e0228&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports